import React, { useState } from "react";
import { Modal, Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import './resetModal.css'
import Error from '../../common/Message/error';
import Success from '../../common/Message/success';
import { resetPassword } from '../endpoints/action';
import useConfiguration from "../../../hooks/useConfiguration";

export default (props) => {
  const config = useConfiguration();
  let show = props.showReset;
  let handleClose = props.handleResetClose;
  let email = props.email;
  let handlePasswordReset = props.handlePasswordReset;
  let successMessage = props.resetSuccess;
  let errorMessage = props.resetError;

  const [showEmail, setShowEmail] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [errors, setErrors] = useState([]);
  const dispatch = useDispatch();

  const sendPassword = (checked) => {
    if (checked) {
      setShowEmail(true);
    } else {
      setShowEmail(false);
    }
  }

  const validateForm = () => {
    const newErrors = {};
    const passwordPattern = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})"
    if (!password || password === '') newErrors.password = "Please enter the Password"
    if (!password.match(passwordPattern)) {
      newErrors.password = "Password must have 8 characters including 1 uppercase, 1 numeric and 1 special character"
    }
    if (!confirmPassword || confirmPassword === '') {
      newErrors.confirmPassword = "Please enter the Confirm Password"
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Password and Confirm Password must be same"
    }
    if (showEmail) {
      if (!newEmail || newEmail === '') newErrors.newEmail = "Please enter the Email"
    }
    return newErrors
  }

  const validateAndSubmit = (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      setErrors([]);
      dispatch(resetPassword(config.baseUrl, {
        email: email,
        password: password,
        isNeedtoSendEmail: showEmail,
        emailSendTo: newEmail,
        sourceWebsite: window.location.hostname
      }))

    }
  }

  return (
    <>
      <div id="resetModalForm">
        <Modal size="md" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Email Update</Modal.Title>
          </Modal.Header>
          {
            errorMessage && <Error errorMessage={errorMessage} />
          }
          {
            successMessage && <Success successMessage={successMessage} />
          }
          <Modal.Body>
            <Form id="resetForm" autoComplete="off" noValidate onSubmit={validateAndSubmit}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Login</Form.Label>
                <Form.Text>{email}</Form.Text>
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>Password*</Form.Label>
                <Form.Control type="text" placeholder="Password"
                  value={password} onChange={e => {
                    setPassword(e.currentTarget.value)
                  }} autoFocus
                  isInvalid={!!errors.password} />
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="mb-3" controlId="confirmpassword">
                <Form.Label>Confirm Password*</Form.Label>
                <Form.Control type="text" placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={e => {
                    setConfirmPassword(e.currentTarget.value)
                  }} isInvalid={!!errors.confirmPassword} />
                <Form.Control.Feedback type="invalid">
                  {errors.confirmPassword}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} className="mb-2" controlId="checkApproval">
                <Form.Check type="checkbox" label="Send Password in Email"
                  onChange={e => {
                    sendPassword(e.currentTarget.checked)
                  }}></Form.Check>
              </Form.Group>
              {showEmail && <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email*</Form.Label>
                <Form.Control type="text" placeholder="Email"
                  value={newEmail}
                  onChange={e => {
                    setNewEmail(e.currentTarget.value)
                  }} isInvalid={!!errors.newEmail} />
              </Form.Group>}
              <Form.Group className="BtnForm">
                <Button id="saveBtn" variant="primary" type="submit" onClick={(e) => validateAndSubmit(e)}>
                  Save Changes
                </Button>
                <Button id="cancelBtn" variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer id="resetFooter">
            <span>[or]</span>
            <Button variant="primary" onClick={handlePasswordReset}>
              Send Password Reset Link
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
